'use client';

import Link from 'next/link';
import type React from 'react';
import { ImgMobileEntity } from '@/features/EntityShow/mobile/ImgMobileEntity/ImgMobileEntity';
import InfoMobileEntity from '@/features/EntityShow/mobile/InfoMobileEntity/InfoEntity';
import type { EntityT } from '@/features/EntityShow/types';
import type { EntityType } from '@/forApp/types/Entity';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from './styles.module.css';

type EntityShowT = {
  entity: EntityT;
  type: EntityType;
};

export const EntityMobileShow: React.FC<EntityShowT> = ({ entity, type }) => {
  return (
    <Link
      href={getRouteHref(ROUTES.ENTITY, { type, slug: entity.slug })}
      className={styles.entityWrap}
    >
      <ImgMobileEntity entity={entity} />
      <InfoMobileEntity entity={entity} />
    </Link>
  );
};
